import Method from './method';

export default Method;
